import script from "./summary-custom-panel.vue?vue&type=script&setup=true&lang=ts"
export * from "./summary-custom-panel.vue?vue&type=script&setup=true&lang=ts"

import "./summary-custom-panel.vue?vue&type=style&index=0&id=8e485bc8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e485bc8"]])

export default __exports__